// extracted by mini-css-extract-plugin
export default {"wired":"qAlCAU","title":"K04S_A","mobile":"kaLvty","image":"KPvS5C","skeleton":"WJN0pu"};